<template>
  <div :class="['banner-plate', { 'banner-plate--compact': compact }]">
    <el-carousel
      :interval="5000"
      arrow="always"
      height="100%"
      ref="slideCarousel"
    >
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="img-wrap">
          <img
            @click="handleBannerClick(item)"
            class="img"
            :src="item.bannerUrl"
          />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
/**
 * list         轮播图列表
 * imgUrl       图片地址
 * autoHeight   true自适应高度  false固定高度
 */
import { getHomeBannerList } from '@/api/home/home.js'
export default {
  props: {
    compact: Boolean
  },
  data() {
    return {
      list: [] // 轮播图列表
    }
  },
  created() {
    this.getHomeBannerList(1)
  },
  methods: {
    //获取首页banner
    getHomeBannerList(id) {
      getHomeBannerList(id).then((res) => {
        if (!res.data) return
        this.list = res.data
      })
    },
    handleBannerClick(item) {
      if (item.linkType == 1) {
        window.location.href = item.linkUrl
      } else {
        window.open(item.linkUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-plate {
  height: 802px;
  width: 1340px;
  margin: 0 auto;
  .el-carousel {
    height: 100%;

    .img-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      background-color: #fff;
      cursor: pointer;

      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    :deep(.el-carousel__arrow) {
      width: 50px;
      height: 50px;
    }
  }
}

.banner-plate--compact {
  width: 724px;
  height: 407px;
}

// 手机端css
.mobile-content {
  .banner-plate {
    width: 375px;
    height: 250px;
    :deep(.el-carousel__button) {
      width: 15px;
    }
    :deep(.el-carousel__arrow) {
      display: none;
    }
  }

  .banner-plate--compact {
    width: 100%;
    height: 194px;
  }
}
</style>
